import { z } from "zod";

export const CheckDiscountCodeSchema = z.object({
  discountCode: z.string().trim().min(1),
});

export type CheckDiscountCodeForm = z.infer<typeof CheckDiscountCodeSchema>;
